import { Component, OnInit, ElementRef } from '@angular/core';
import { AuthenticationService } from '../../../authentication.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { PaymentsService } from '../../../services/payments-service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { ModalService } from '../../../services/modals.service';
import { arrayIsDefinedAndContainsKey } from '../../../shared/array-functions';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { subscriptionViewSpanish } from '../subscription.static.data';

@Component({
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['../../../app.component.css']
})
export class MakePaymentComponent implements OnInit {
  // Static data
  subscriptionView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  processResponseMessage: string;
  transactionCompleted: boolean;
  // User data
  billingAddress: object;

  constructor(public subscriptionService: SubscriptionService, private authenticationService: AuthenticationService, private paymentsService: PaymentsService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.subscriptionView = subscriptionViewSpanish;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
    this.transactionCompleted = true;
  }

  ngOnInit() {
  }

  selectPaymentMethod(paymentMethod) {
    this.subscriptionService.selectedMethodForOneTimePayment = paymentMethod;
  }

  getBillingAddressOfSelectedPaymentMethod () {
    this.paymentsService.getBillingAddressByPaymentMethodId(this.subscriptionService.selectedMethodForOneTimePayment['PaymentMethodID']).subscribe((response) => {
      if(arrayIsDefinedAndContainsKey(response, 'CMS_SAM_Get_CustomerBillingAddress_ByPaymenyMethodId')) {
        this.billingAddress = response['CMS_SAM_Get_CustomerBillingAddress_ByPaymenyMethodId'][0];
      }
    });
  }

  makePayment() {
    this.transactionCompleted = false;
    this.paymentsService.submitPayment(this.subscriptionService.selectedSubscriptionId, this.subscriptionService.selectedMethodForOneTimePayment['PaymentMethodID'], this.subscriptionService.selectedSubscription['RenewalPrice']).subscribe((response) => {
      this.closeModal('#makePaymentModal');
      this.closeModal('#confirmPaymentModal');
      if (response.EdgilMessage === this.paymentsService.edgilProcessResultResponse.success) {
        this.processResponseMessage = 'Tu pago ha sido procesado exitosamente.';
        this.paymentsService.getPaymentHistoryList(this.subscriptionService.selectedSubscriptionId);
        this.subscriptionService.getUpdatedSelectedSubscription();
        this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Thank_You_Pago_Confirmado');
      } else if (response.EdgilMessage === this.paymentsService.edgilProcessResultResponse.decline) {
        this.processResponseMessage = 'Tu pago no pudo ser procesado. Por favor verifica el método de pago y vuelve a intentarlo.';
      } else {
        this.processResponseMessage = 'Tu pago no pudo ser procesado. Estamos confrontando dificultades técnicas. Para más información, favor de llamar a Servicio al Cliente al 787-641-8800.';
      }
      this.openModal('#responseModal');
      this.transactionCompleted = true;
    });
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/make-payment/make-payment.component.ts